import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Fetch function for page data
function fetchPageData(query) {
    const beURL = localStorage.getItem('BeURL');
    return axios.get(`${beURL}search/pages/${query}`).then(res => res.data.pages);
}

// Custom hook for searching pages
export const useSearchPages = (query) => {
    return useQuery({
        queryKey: ['SearchpageData', query], // Include query in queryKey for re-fetching on change
        queryFn: () => fetchPageData(query),
        enabled: !!query, // Only run the query if query is not empty
    });
};
